import React, { useState } from "react";
// import SectionTitle from "../../components/Common/SectionTitle";
import SingleService from "../../components/Service/SingleService";
import Loader from "../../Loader";
import { useSelector } from "react-redux";
import he from "he";
import { decodeAndStripHtml, decodeHtml } from "../../components/util";
import { S3_BASE_URL } from "../../../../Service";

const Service = () => {
  const [services, setServices] = useState(
    useSelector((state) => state.data).service
  );
    const { page } = useSelector((state) => state.data);
    const rawHtml1 = page.data["service-heading"]?.htmlContent || "";
  
    const htmlContent = decodeHtml(rawHtml1);

  const [loadingServices, setLoadingServices] = useState(false);

  return (
    <div
      id="rs-service"
      className="rs-services main-home gray-bg pt-110 pb-120 md-pt-70 md-pb-70"
    >
      <div className="container">
        {/* <SectionTitle
          sectionClass="sec-title2 text-center mb-46"
          subtitleClass="sub-text"
          subtitle="Services"
          titleClass="title"
          title="We Are Offering All Kinds of IT Solutions Services"
          effectClass="heading-line"
        /> */}
     {
      htmlContent && (
        <div id="extraP" dangerouslySetInnerHTML={{ __html: htmlContent}}/>
      )
     }
        <div className="row">
          {loadingServices ? (
            <Loader />
          ) : services.length > 0 ? (
            services.map((service) => (
              <div key={service._id} className="col-lg-4 col-md-6 mb-30">
                <SingleService
                  itemClass="services-item"
                  serviceId={service._id}
                  serviceImage={`${S3_BASE_URL}/${service.serviceImage}`}
                  // serviceURL={service.serviceURL || "#"}
                  // serviceURL={`/service/service-details/${slugify(
                  //   service.title
                  // )}`}
                  Title={he.decode(service.title)}
                  Text={decodeAndStripHtml(service.shortDescription)}
                />
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <p>No services available at the moment.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Service;
